import { render, staticRenderFns } from "./compWithdrawalBankCardConfig.vue?vue&type=template&id=7fdaf9b1&scoped=true"
import script from "./compWithdrawalBankCardConfig.vue?vue&type=script&lang=js"
export * from "./compWithdrawalBankCardConfig.vue?vue&type=script&lang=js"
import style0 from "./compWithdrawalBankCardConfig.vue?vue&type=style&index=0&id=7fdaf9b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdaf9b1",
  null
  
)

export default component.exports